<template>
  <div>
    <v-layout
      fill-height
      align-center
    >
      <v-spacer />
      <v-btn
        :disabled="disabled"
        color="primary"
        small
        icon
        @click="showNoteDialog('add')"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-dialog
        v-model="noteDialog"
        persistent
        width="500"
      >
        <v-card>
          <v-card-text>
            <v-form>
              <v-textarea
                v-model="note"
                label="Заметка"
              />

              <v-btn
                small
                color="primary"
                :disabled="loading"
                :loading="loading"
                @click="save"
              >
                Ок
              </v-btn>
              <v-btn
                small
                @click="noteDialog = false"
              >
                Отмена
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <div
      class="pa-1 worked-variant-table"
      :style="{
        height: blockNotesHeight + 'px',
        'overflow-y': 'auto',
        'overflow-x': 'hidden'
      }"
    >
      <v-list>
        <v-list-tile
          v-for="item in notes"
          :key="item.id"
          class="compact"
        >
          <v-list-tile-content>
            <div>
              <span
                style="color: rgba(0,0,0,.54);"
              >{{ item.author }}: {{ item.date | dateTime }} </span><span> {{ item.text }}</span>
            </div>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-layout>
              <span>
                <v-btn
                  small
                  icon
                  :disabled="disabled"
                  class="mx-1"
                  @click="showNoteDialog('change', item.id, item.text)"
                >
                  <v-icon
                    color="grey darken-2"
                    small
                  >edit</v-icon>
                </v-btn>
              </span>
              <span>
                <v-btn
                  small
                  icon
                  :disabled="disabled || loading"
                  @click="deleteNote(item.id)"
                >
                  <v-icon
                    small
                    color="grey darken-2"
                  >delete</v-icon></v-btn>
              </span>
            </v-layout>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </div>
  </div>
</template>
<script>
import {
  createShippingNote,
  updateShippingNote,
  deleteShippingNote,
} from "../../../../backend/shippingsApi.js";
import auth from "../../../../auth.js";

export default {
  props: ["disabled", "id"],
  data() {
    return {
      action: null,
      noteDialog: false,
      note: "",
      noteId: 0,
      user: null,
      loading: false,
    };
  },
  computed: {
    notes() {
      return this.$store.getters["shipping/notes"];
    },
    blockNotesHeight() {
      return window.innerHeight - 498;
    },
  },
  created() {
    this.user = auth.getUser();
  },
  methods: {
    save() {
      if (this.action === "add") {
        this.addNote();
      } else if (this.action === "change") {
        this.changeNote();
      }
    },
    async addNote() {
      this.loading = true;
      try {
        this.loading = true;
        await createShippingNote(this.id, this.note);
        this.loading = false;
      } catch (error) {
        this.loading = false;
        if (error.message) {
          this.noteDialog = false;
          this.showError(error.message);
        } else {
          this.noteDialog = false;
          throw error;
        }
      }
      this.noteDialog = false;
      this.note = "";
      this.noteId = 0;
      this.action = null;
      await this.$store.dispatch("shipping/getNotes");
    },
    async changeNote() {
      this.loading = true;
      await updateShippingNote(this.id, this.noteId, this.note);
      this.noteDialog = false;
      this.note = "";
      this.noteId = 0;
      this.action = null;
      await this.$store.dispatch("shipping/getNotes");
      this.loading = false;
    },
    async deleteNote(noteId) {
      if (!this.disabled) {
        this.loading = true;
        await deleteShippingNote(this.id, noteId);
        await this.$store.dispatch("shipping/getNotes");
        this.loading = false;
      }
    },
    showNoteDialog(action, noteId, note) {
      if (!this.disabled && this.user.hasEmployee) {
        this.action = action;
        this.noteId = noteId;
        this.note = note;
        this.noteDialog = true;
      } else {
        this.showInfo("Пользователь не привязан к сотруднику");
      }
    },
  },
};
</script>
